import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_FINALIZE } from "../../config/config.json";
  
const baseQuery = fetchBaseQuery({
    baseUrl: API_FINALIZE,
    extraOptions: { timeout: 30000 },
    prepareHeaders: (headers) => {
        headers.set('content-type', 'application/json')
        headers.set('access-control-allow-origin', '*')
        headers.set('accept', '*/*')
        /* const token = localStorage.getItem("token")
        if (token) headers.set('Authorization', `Bearer ${token}`) */
        return headers
    }
});

export const microserviceFinalizeApi = createApi({
    reducerPath: 'microserviceFinalizeApi',
    baseQuery,
    // tagTypes: Object.values(TAG_TYPES),
    endpoints: () => ({})
});